
//
// Module intercepting form submissions to ensure invalid dates get flagged and not silently ignored
//
rs.module("common/form-dates", [],

    function () {

        // Initialize the module
        function initialize(invalidMarker) {

            // manipulate form values when the form is submitted
            $("body").on("formdata", "form", function (event) {

                var form = event.target;
                var formData = event.originalEvent.formData;

                // Find all the date inputs that are invalid, and make sure we send some invalid stuff
                // so the server knows it was invalid.  This is primarily an issue with non-required dates,
                // because invalid dates by default come accross as blank, which for non-required is acceptable
                // so nothing ends up happening.
                for (var entry of formData) {

                    var name = entry[0];
                    var input = $(form).find(`[name='${name}']`)[0];

                    if (input && input.type == "date") {

                        if (input.validity.badInput && !input.validity.valueMissing) {
                            formData.set(name, invalidMarker);
                        }
                    }
                }
            });
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);
